import React, { createRef } from 'react';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType as InsTypeEnum } from 'constants/enums/insType.enum';
import MainVisual from 'components/Home/MainVisual';
import { IMainVisualNav, MainVisualNavElemTypeEnum } from 'components/Home/MainVisual/types';
import Advantage from 'components/MemberCenter/ElectronicPolicy/Advantage';
import Compare from 'components/MemberCenter/ElectronicPolicy/Compare';
import FlowRemind from 'components/Home/FlowRemind';
import QuestionAnswer from 'components/MemberCenter/QuestionAnswer';
import Download from 'components/MemberCenter/ElectronicPolicy/Download';
import service from 'bff/services/service/electricPolicyService';
import { QAClass } from 'constants/enums/qaClass.enum';
import { IProps, IState } from './types';
import { Inscat } from 'bff/models/info';
import _ from 'lodash';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';

class ElectronicPolicy extends React.Component<IProps, IState> {
  private sectionRef = createRef<HTMLDivElement>();
  state:IState = {
    inscats: new Array(0),
    qaInfos: new Array(0),
    ePolicyCodes: new Array(0),
    twcaSWSysOpts: new Array(0),
    twcaUGSysOpts: new Array(0)
  }

  componentDidMount = async () => {
    const initSetting = await service.fetchInitSetting(QAClass.EPOLICY);

    this.setState({
      inscats: [...initSetting.inscats],
      qaInfos: [...initSetting.qaInfos],
      ePolicyCodes: [...initSetting.ePolicyCodes],
      twcaSWSysOpts: [...initSetting.twcaSWSysOpts],
      twcaUGSysOpts: [...initSetting.twcaUGSysOpts]
    });
  }

  componentDidUpdate () {
    // console.log('componentDidUpdate ', this.state);
  }

  /**
   * @description 點擊 SCROLL 按鈕，視窗滾動至「電子保單好處多」區塊
   */
  handleScrollToSection = () => {
    // 執行 scrollIntoView Method，將視窗滾動至「電子保單好處多」區塊
    this.sectionRef.current && this.sectionRef.current.scrollIntoView();
    // 視窗滾動高度需減去 Header 高度
    const scrolledY = window.scrollY;
    const headerHeight = 72;
    window.scroll(0, scrolledY - headerHeight);
  };

  render () {
    // #region 產生主視覺區塊

    let mainVisual;
    if (this.state.inscats.length > 0) {
      const navs: IMainVisualNav[] = new Array(0);
      const backgroundImages = new Array(0);

      _.forEach(this.state.inscats, (inscat:Inscat) => {
        navs.push({
          elemType: MainVisualNavElemTypeEnum.Basic,
          insType: InsTypeDefinesEN[`${inscat.INS_TYPE_ID}` as InsTypeEnum],
          title: inscat.INS_TYPE_NAME
        });

        backgroundImages.push({
          theme: InsTypeDefinesEN[`${inscat.INS_TYPE_ID}` as InsTypeEnum],
          // pcLeftImgPath: require(`assets/images/${inscat.IMAGE_LEFT_PC}`),
          // pcRightImgPath: require(`assets/images/${inscat.IMAGE_RIGHT_PC}`),
          // mobileImgPath: require(`assets/images/${inscat.IMAGE_LEFT_MOBILE}`)
          pcLeftImgPath: commonService.convertImageUrl(inscat.IMAGE_LEFT_PC),
          pcRightImgPath: commonService.convertImageUrl(inscat.IMAGE_RIGHT_PC),
          mobileImgPath: commonService.convertImageUrl(inscat.IMAGE_LEFT_MOBILE)
        });
      });

      mainVisual = (
        <MainVisual
          title={commonService.getCodeMsg(this.state.ePolicyCodes, CodeId.U001)}
          subTitle={commonService.getCodeMsg(this.state.ePolicyCodes, CodeId.U002)}
          navs={navs}
          backgroundImages={backgroundImages}
          onScroll={this.handleScrollToSection}
        />
      );
    }

    // #endregion

    // #region 取得電子保單流程
    const flowItems = [
      {
        title: 'Step1',
        // icon: require('assets/images/pen-checked-blue-icon.png'),
        icon: commonService.convertImageUrl('pen-checked-blue-icon.png'),
        text: commonService.getCodeMsg(this.state.ePolicyCodes, CodeId.FLOW_STEP1)
      },
      {
        title: 'Step2',
        // icon: require('assets/images/phone-email-blue-icon.png'),
        icon: commonService.convertImageUrl('phone-email-blue-icon.png'),
        text: commonService.getCodeMsg(this.state.ePolicyCodes, CodeId.FLOW_STEP2)
      },
      {
        title: 'Step3',
        // icon: require('assets/images/phone-message-blue-icon.png'),
        icon: commonService.convertImageUrl('phone-message-blue-icon.png'),
        text: commonService.getCodeMsg(this.state.ePolicyCodes, CodeId.FLOW_STEP3)
      },
      {
        title: 'Step4',
        // icon: require('assets/images/people-auth-blue-icon.png'),
        icon: commonService.convertImageUrl('people-auth-blue-icon.png'),
        text: commonService.getCodeMsg(this.state.ePolicyCodes, CodeId.FLOW_STEP4)
      }
    ];
    // #endregion

    return (
      <div className="electronic-policy">
        {/* 主視覺 */}
        {mainVisual}
        {/* 電子保單好處多 */}
        <Advantage refSetting={this.sectionRef} ePolicyCodes={this.state.ePolicyCodes} />
        {/* 傳統保單 VS 電子保單 */}
        <Compare ePolicyCodes={this.state.ePolicyCodes} />
        {/* 取得電子保單流程 */}
        <FlowRemind
          title={commonService.getCodeMsg(this.state.ePolicyCodes, CodeId.FLOW_TITLE)}
          desc={commonService.getCodeMsg(this.state.ePolicyCodes, CodeId.FLOW_TITLE1)}
        >
          <FlowRemind.Flow
            items={flowItems}
            sliderMobileConfig={{ slidesPerView: 1 }}
          />
        </FlowRemind>
        {/* 電子保單 Q&A */}
        <QuestionAnswer title="電子保單Q&A" qaInfos={this.state.qaInfos} />
        {/* 軟體下載 */}
        <Download twcaSWSysOpts={this.state.twcaSWSysOpts} twcaUGSysOpts={this.state.twcaUGSysOpts} />
      </div>
    );
  }
};

export default ElectronicPolicy;
